applicationsSubNavbar.service('ApplicationsSubNavbarService',
    function ($location, authServiceFactory, ApplicationService, TabsService, $timeout, $state, $stateParams, DateService,
              BinFactory, BinService, MainContentService, ApplicationSideBarService, FirstRunModalService, ResetService, DetermineAwardService, 
              $modal, CommitteeModeModelService, SliderService, SliderFactory, CalculationService, SchoolModelService) {


        // hiddenBin = true slides the bin out of sight
        var hiddenBin = false;
        var openBin = function() { return hiddenBin; }
        var hideBin = function(open) { hiddenBin = open; }

        // hiddenApp = true slides the application out of site
        var hiddenApp = false;
        var openApp = function() { return hiddenApp; }
        var hideApp = function(open) { hiddenApp = open; }

        // sideNavActive controls the view of the application/bin area (minus the bin sidenav)
        // true slides the bin into view
        // false slides the application into of view
        var sideNavActive = true;
        var openSideNav = function(location) { // slide the bin into view
            hideApp(true);
            hideBin(false);
            ApplicationService.clear();
            if (location) { //location is specified (clicked on navbar links)
                sideNavActive = true; 
                $state.go("schoolside." + location).then(function() {
                });
            }
            else { //location not specified (clicked on app breakcrumb)
                if(!$state.includes('schoolside.archive') && !$state.includes('schoolside.archives')) {
                    $state.go("schoolside.applications");
                }
                else if($state.includes('schoolside.archive') || $state.includes('schoolside.archives')) {
                    $state.go("schoolside.archives");
                }
                sideNavActive = true; 
            }
        }
        var closeSideNav = function() { //slide the application into view
            sideNavActive = false; 
            hideApp(false);
            $(".loading-area").addClass("hidden");
        }
        var getSideNavActive = function() { 
            return sideNavActive; 
        }

        var applicationClick = function(app)
        {
            hideApp(true); //slide app out
            hideBin(true); //slide bin out
            ApplicationService.setFamilyNo(0);
            if(!$state.includes('schoolside.archive') && !$state.includes('schoolside.archives')) {
                $state.go("schoolside.application", {"applicationID": app.applicationID}).then(function() {
                    getPrevNextApplication();
                });
            }
            else if($state.includes('schoolside.archive') || $state.includes('schoolside.archives')) {
                $state.go("schoolside.archive", {"applicationID": app.applicationID}).then(function() {
                    getPrevNextApplication();
                });
            }
            $(".loading-area").removeClass("hidden");
        }

        // For the currently selected application, prevNext stores applicationIDs for
        // the previous and next applications in the current bin list.
        var prevNext;
        var getPrevNextApplication = function()
        {
            prevNext = {};
            var items = BinFactory.get();
            ApplicationService.setFamilyNo(0);
            if (typeof items !== 'undefined' && typeof ApplicationService.getApplicationID() !== 'undefined')
            {
                for(var i = 0; i < items.length; i++)
                {
                    if (ApplicationService.getApplicationID() == items[i].applicationID)
                    {
                        break;
                    }
                }
                if (i !== 0)
                    prevNext.prev = items[i - 1].applicationID;
                if ((items.length - 1) > i)
                    prevNext.next = items[i + 1].applicationID;
            }
        }

        // transition to the next application in the bin list
        var nextApplication = function()
        {
            ApplicationService.setFamilyNo(0);
            SliderService.closeSlider();
            hideApp(true); //slide app out
            if (typeof prevNext.next !== 'undefined')
            {
                applicationClick({applicationID: prevNext.next});
            }
            else
            {
                openSideNav();
            }
        }

        // transition to the previous application in the bin list
        var previousApplication = function()
        {
            ApplicationService.setFamilyNo(0);
            SliderService.closeSlider();
            hideApp(true); //slide app out
            if (typeof prevNext.prev !== 'undefined')
            {
                applicationClick({applicationID: prevNext.prev});
            }
            else
            {
                openSideNav();
            }

        }

        var _loadApplication =  function(applicationID)
        {
            hideApp(true); //slide app out
            hideBin(true); //slide bin out

            ApplicationService.getData(applicationID).then(function ()
            {
                CalculationService.reCalc();
                MainContentService.setActiveDiv('applicationOverview');
                TabsService.setActiveTab("awardData");
                closeSideNav();
                getPrevNextApplication();
                
                var isArchiveUrl = $location.$$path.split("/")[1] == "archive" ? true : false;
                var isArchiveApp = ApplicationService.getAwardData().app[0].App_Fin_Year === parseInt(authServiceFactory.getAuth().currentYear) ? false : true;
                if ( (isArchiveUrl && isArchiveApp) || (!isArchiveUrl && !isArchiveApp) || (isArchiveUrl && !isArchiveApp))
                {
                    ResetService.init();

                    for(var i = 0; i < BinFactory.get().length; i++)
                    {
                        if (BinFactory.get()[i].applicationID == applicationID)
                            BinFactory.currentBinAppRef = BinFactory.get()[i];
                    }
                    if (ApplicationService.getAwardData().app[0].Status_New==1 && !authServiceFactory.auth.isISMon)
                        ApplicationSideBarService.setBin('Status_Viewed');
                }
                let title = 'Determine Award';
                if (SchoolModelService.get()[0].Award_Pref_1 == 1)
                    title = 'Determine Tuition';
                if (DetermineAwardService.resetAwardComplete()!=='active')
                    SliderService.pushSlider(new SliderFactory('determineAward/partials/determineAward', title, 'l'));


                if (ApplicationService.getAwardData().app[0].App_Fin_Year == DateService.getCurrentYear() + 1)
                {
                    $modal.open({
                        templateUrl: "fast/submodules/schoolside/applications/submodules/applicationsSubNavbar/partials/future.html?v=" + versionNo,
                        controller: "FutureController",
                        keyboard: false,
                        backdrop: 'static'
                    });
                } 

            });
        }
        return {
            openSideNav: openSideNav,
            closeSideNav: closeSideNav,
            getSideNavActive: getSideNavActive,

            openBin: openBin,
            openApp: openApp,

            applicationClick: applicationClick,
            nextApplication: nextApplication,
            previousApplication: previousApplication,

            _loadApplication: _loadApplication
        };
    });
